export default __webpack_public_path__ + "static/warranty_insurance_paragraph-e3a3f5a009216e8949ae7f073162c8d2.webp";